/* unplugin-vue-components disabled */import script from "./PlainButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlainButton.vue?vue&type=script&setup=true&lang=ts"

import "./PlainButton.vue?vue&type=style&index=0&id=223b5ddb&lang=less"

const __exports__ = script;

export default __exports__